import React from 'react';
import { Link } from 'react-router-dom';
import { Button } from '@/components/ui/button';
import { Heart, ChevronRight } from 'lucide-react';
import { copy } from '@/copy';

const LandingPage = () => {
  return (
    <div className="min-h-screen bg-[#F5F5F5]">
      {/* Hero Section - Full viewport */}
      <section 
        className="relative min-h-screen flex flex-col"
        style={{
          backgroundImage: 'url(/hero-background.png)',
          backgroundSize: 'cover',
          backgroundPosition: 'center'
        }}
      >
        <div className="absolute inset-0 bg-[#1D2D44]/40"></div>
        
        {/* Minimal Header */}
        <header className="relative z-10 px-4 py-4">
          <nav className="max-w-4xl mx-auto flex items-center justify-between">
            <span className="font-serif text-lg text-white">
              Our Love <Heart className="inline-block w-4 h-4 text-[#C9A84C] mx-0.5" strokeWidth={1.5} /> Connection
            </span>
            
            <div className="flex items-center gap-6">
              <Link 
                to="/about" 
                className="text-sm text-white/80 hover:text-white transition-colors"
                data-testid="nav-about-link"
              >
                {copy.nav.about}
              </Link>
              <Link 
                to="/login" 
                className="text-sm text-white/80 hover:text-white transition-colors"
                data-testid="nav-signin-link"
              >
                {copy.nav.signIn}
              </Link>
            </div>
          </nav>
        </header>
        
        {/* Hero Content */}
        <div className="relative z-10 flex-1 flex items-center justify-center px-4">
          <div className="text-center max-w-2xl mx-auto animate-fade-in">
            {/* App Name */}
            <h1 className="font-serif text-4xl sm:text-5xl lg:text-6xl text-white tracking-tight leading-tight mb-6">
              Our Love <Heart className="inline-block w-8 h-8 sm:w-10 sm:h-10 lg:w-12 lg:h-12 text-[#C9A84C] mx-1" strokeWidth={1.5} /> Connection
            </h1>
            
            {/* Tagline */}
            <p className="text-lg sm:text-xl text-[#B89B5E] font-light mb-8 tracking-wide">
              {copy.brand.tagline}
            </p>
            
            {/* Brief Introduction */}
            <p className="text-base sm:text-lg text-white/80 mb-12 max-w-xl mx-auto leading-relaxed">
              {copy.landing.introduction}
            </p>
            
            {/* CTAs */}
            <div className="flex flex-col sm:flex-row gap-4 justify-center items-center">
              {/* Primary CTA */}
              <Link to="/register">
                <Button 
                  data-testid="hero-begin-journey-btn"
                  className="bg-[#1D2D44] text-[#B89B5E] hover:bg-[#1F1F1F] rounded-full px-8 py-6 text-lg font-medium shadow-lg transition-all duration-300 hover:scale-[1.02] border border-[#B89B5E]/30"
                >
                  {copy.landing.primaryCta}
                  <ChevronRight className="ml-2 w-5 h-5" />
                </Button>
              </Link>
              
              {/* Secondary CTA - Subtle */}
              <Link 
                to="/login"
                className="text-white/70 hover:text-white text-sm transition-colors"
                data-testid="hero-signin-link"
              >
                {copy.landing.secondaryCta}
              </Link>
            </div>
          </div>
        </div>
        
        {/* Scroll indicator */}
        <div className="relative z-10 pb-8 flex justify-center">
          <div className="w-6 h-10 border-2 border-white/20 rounded-full flex justify-center pt-2 animate-gentle-pulse">
            <div className="w-1.5 h-3 bg-[#B89B5E]/60 rounded-full"></div>
          </div>
        </div>
      </section>

      {/* Simple Footer */}
      <footer className="py-8 px-4 bg-[#1D2D44]">
        <div className="max-w-4xl mx-auto text-center">
          <p className="text-white/60 text-sm">
            {copy.brand.copyright(new Date().getFullYear())}
          </p>
        </div>
      </footer>
    </div>
  );
};

export default LandingPage;
